import { Membership } from '@models';

export interface MyMembershipsResult {
  myMemberships: Membership[];
}
